export default __webpack_public_path__ + "static/media/nazim.0587e856.jpeg";